module.exports = __webpack_public_path__ + "img/mh.c8caa175.png";